import { useContext } from 'react'
import { PrecificationContext } from '@/context/PrecificationContext'

export const usePrecification = () => useContext(PrecificationContext)
